export function showThirdAlreadyExistModal(window, formID) {
    var options = {
        type: "warning",
        resizable: false,
        noclose: true,
        title: Loc.g("Information Sellsy"),
        buttons: [
            {
                text: Loc.g("Annuler"),
                'class': 'btn btn-default',
                click: function () {
                    $(this).dialog("close");
                }
            },
            {
                text: Loc.g("Créer"),
                'class': 'btn btn-primary',
                click: function () {
                    $(this).dialog("close");
                    $(`#${ formID } #checkDuplicate`).val('N');
                    $(`#${ formID }`).submit();
                }
            },
        ]
    };

    var msg = Loc.g("Il existe déjà une ou plusieurs sociétés avec ce nom, êtes vous sur de vouloir la re-créer ?");
    window.alert(msg, options);
}